import * as ACTIONS from "./../actions/actionConstants";

const initialState = {
  changes: {
    tempValue: null
  }
};

const tempReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.STORE_TEMP_POINT: {
      return {
        ...state,
        changes: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default tempReducer;



// WEBPACK FOOTER //
// ./src/reducers/tempReducer.js